import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import farmService from "../../services/farm-service";
import { Divider, message, Spin } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import Swal from "sweetalert2";



const AdminFarms = () => {
  let navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [totalHectares, setTotalHectares] = useState(0);
  const [list, setList] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showSave, setShowSave] = useState(true);
  const [title, setTitle] = useState("Ingresar finca");
  const [sessionUser, setSessionUser] = useState("admin");

  const optionsState = [
    { id: true, name: "ACTIVA" },
    { id: false, name: "INACTIVA" },
  ];

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();



  const goToMapFarm = (farm) => {
    localStorage.setItem("farmId", farm._id);
    localStorage.setItem("farmName", farm.name);
    navigate("/map-farm");
  };



  const nameToUpper = (e) => {
    let value = e.target.value.toUpperCase();
    setValue("farmName", value);
  };


  const adminSection = (farm) => {
    localStorage.setItem("farmId", farm._id);
    localStorage.setItem("farmName", farm.name);
    navigate("/admin-section");
  };



  ////FUNCIONES QUE USAN EL SERVICIO FARMSERVICE
  ////FUNCIONES QUE USAN EL SERVICIO FARMSERVICE
  const getListFarms = async () => {
    setLoading(true)
    const response = await farmService.getListAndHectares();

    const listado = response?.data || null;
    const hectares = response?.hectares || null;
    if (listado) {
      setList(listado);
    }
    if (hectares) {
      setTotalHectares(hectares)
    }
    setLoading(false)

  };

  const updateFarm = async () => {
    const id = getValues("id");
    const name = getValues("farmName");
    const state = getValues("state");
    const data = { id, name, state };
    setLoading(true)
    const success = await farmService.update(data);
    if (success) {
      reset();
      getListFarms();
      setShowEdit(false);
      setShowSave(true);
      setTitle("Ingresar finca");
      toast('Realizado.', { autoClose: 1500 });
    }

    setLoading(false)
  };

  const customSubmit = async (data) => {

    const data_insert = { ...data, name: data.farmName }

    const pin = getValues("pin")
    if (pin != "2525") {
      toast.error('Usuario sin privilegios!', { autoClose: 1000 });
      return;
    }


    setLoading(true)
    const success = await farmService.insert(data_insert);
    if (success) {
      reset();
      getListFarms();
      toast('Realizado.', { autoClose: 1500 });
    }
    setLoading(false)
  };

  const cancelar = async () => {
    setShowEdit(false);
    setShowSave(true);
    setTitle("Ingresar finca");
    reset();
  };

  const getFarm = async (farmId) => {
    const farm = await farmService.getFarm(farmId);
    if (farm) {
      setValue("id", farm._id);
      setValue("farmName", farm.name);
      setValue("state", farm.state);
      setShowEdit(true);
      setShowSave(false);
      setTitle("Editar finca");
    }
  };



  const deleteFarm = async (id, name) => {
    
    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios.', { autoClose: 1000 });
      return;
    }
    else {
      Swal.fire({
        title: `Eliminar  finca`,
        html: `Desea eliminar ${name}, <br/> sus secciones, lotes, lineas y palmas? <br/> <em>(Solo puede eliminar fincas sin tareas asociadas)</em> `,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        denyButtonText: `Conservar`
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          const data = { id };
          const response = await farmService.deleteFarm(data);
          console.log(response)
          if (response.success) {
            getListFarms();
            toast(response.message, { autoClose: 1000 });
          }
          else {
            toast.error(response.error, { autoClose: 1000 });
          }          
          setLoading(false)
        }
      });
    }
  }



  useEffect(() => {
    getListFarms();
    setValue("farmName", "");
    setValue("pin", "");
    const username = localStorage.getItem("username");
    setSessionUser(username)
    if (username == "superadmin") {
      setValue("pin", "2525")
    }
  }, []);


  return (
    <div className="row p-4">
      <ToastContainer />

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >GESTIÓN DE FINCAS</Divider>
      </div>


      <div className="col-12 col-sm-4">
        <div className="card p-4">
          <form className="form-react" onSubmit={handleSubmit(customSubmit)}>
            <div className="row">
              <div className="card-title">
                <h3 className="text-secondary" >{title}</h3>
                <hr></hr>
              </div>

              <div className=" col-12 d-none">
                <label>Id finca</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("id")}
                />
              </div>

              <div className=" col-12">
                <label>Nombre</label>
                <input
                  type="text"
                  autoComplete="off"
                  onKeyUp={nameToUpper}
                  className="form-control"
                  {...register("farmName", { required: true, minLength: 3 })}
                />
                {errors.name?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
                {errors.name?.type === "minLength" && (
                  <small className="text-danger">Minimo 10 caracteres</small>
                )}
              </div>

              <div className=" col-6">
                <label>Estado</label>
                <select className="form-control" {...register("state")}>
                  {optionsState.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>



              <div className=" col-6">
                <label>PIN</label>
                <input
                  type="password"
                  autoComplete="off"
                  className="form-control bg-light"
                  {...register("pin")}
                />
              </div>


              <div className={showEdit ? " col-6" : "d-none"}>
                <label>&nbsp; </label>

                <Spin spinning={loading}>
                  <button
                    className="btn btn-primary w-100"
                    type="button"
                    onClick={() => updateFarm()}
                  >
                    <i className="bi bi-save fa-lg" /> Editar
                  </button>
                </Spin>
              </div>

              <div className={showSave ? " col-6" : "d-none"}>
                <label>&nbsp; </label>

                <Spin spinning={loading}>
                  <button className="btn btn-primary w-100" type="submit">
                    <i className="bi bi-save fa-lg m-2" /> Guardar
                  </button>
                </Spin>
              </div>

              <div className=" col-6">
                <label>&nbsp; </label>
                <button
                  className="btn btn-secondary w-100"
                  type="button"
                  onClick={() => cancelar()}
                >
                  <i className="bi bi-x-square fa-lg m-2" /> Cancelar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>


      <div className="col-12 col-sm-7">
        <div className="card p-4">
          <div className="card-title ms-2">
            <h3 className="text-secondary mx-3">Listado de fincas</h3>
            <hr></hr>
            <h5 className="text-dark mx-3">Hectáreas sembradas: {totalHectares}</h5>
            <div className="tbl-container bdr">

              <Spin spinning={loading}>

                <div className="table-responsive">
                  <table className="table">
                    <thead className="table-primary">
                      <tr>
                        <th >Nombre</th>
                        <th >Hectáreas</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((farm) => (
                        <tr key={farm._id}>
                          <td>{farm.name}</td>
                          <td>{farm.hectares}</td>
                          <td style={{ width: "370px",textAlign:'center' }}>
                            <button
                              className="btn btn-primary"
                              onClick={() => getFarm(farm._id)}
                            >
                              <i className="bi bi-pencil-square fa-lg m-1" /> Editar
                            </button>

                            <button
                              className="btn btn-primary ms-2"
                              onClick={() => adminSection(farm)}
                            >
                              <i className="bi bi-card-checklist fa-lg m-1" />
                              Gestionar Secciones
                            </button>

                            <button
                              className={farm.hectares>0?"btn btn-info ms-2":"d-none"}
                              onClick={() => goToMapFarm(farm)}
                            >
                              <i className="bi bi-map m-2"></i>
                            </button>


                            <button
                              className={sessionUser == "superadmin" ? "btn btn-danger ms-2 fs-6" : "d-none"}
                              onClick={() => deleteFarm(farm._id, farm.name)}
                            >
                              <i className="bi bi-trash fa-lg m-2" />
                            </button>


                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Spin>
            </div>
          </div>
        </div>

      </div>




    </div>
  );
};

export default AdminFarms;
